import Chip from "@mui/material/Chip";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { DreamMarkdownReader } from "@portal/app/_components/ui-elements/DreamMarkdown/DreamMarkdownReader";

// The card's one heading. These pages target vocation searches ("medical assistant program"), and
// that text lives here rather than in the provider name — school names are national brands that
// rank for themselves. `DreamSearchResult`'s `Title` renders the provider name as a paragraph so
// each card contributes exactly one heading. Props spread last, so a consumer can override.
export const DreamSearchResultProgramName = (props: TypographyProps) => (
  <ProgramName variant="new_h3" {...props} />
);

const ProgramName = styled(Typography)`
  margin: 0;
  font-family: inherit;
  text-transform: none;
`;

export const DreamSearchResultMarkdownDescription = styled(DreamMarkdownReader)`
  overflow: hidden;

  // Following lines here are for "line clamping":
  // https://css-tricks.com/line-clampin/
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 4.25rem; // cross-browser compatibility for line-clamp; test this on ios safari if you change it
`;

export const DreamSearchResultProgramHighlights = styled("ul")`
  margin: 0.25rem 1rem;
  word-wrap: break-word;
`;

export const DreamSearchCardChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "$backgroundColor",
})<{ $backgroundColor?: string | null }>`
  font-weight: 600;
  font-size: 14px;
  color: #212121;
  background-color: ${({ $backgroundColor }) => $backgroundColor || "#F5F2EA"};
  border-radius: 4px;
`;
